<template>
    <div class="login-page">
        <b-card class="login-form">
            <div>
                <!--img class="logo" src="@/assets/images/splash.png"/!-->
                <h4 class="mb-4">Sign in</h4>
                <p>Welcome back, please login to your account.</p>
            </div>

            <div>
                <validation-observer v-slot="{ invalid }">
                    <validation-provider rules="email|required" v-slot="{errors}">
                        <b-form-input autocomplete="off" name="email" type="text" v-model="email" />
                        <span class="text-danger text-sm" v-if="0">{{ errors[0] }}</span>
                    </validation-provider>

                    <validation-provider rules="required|min:4" v-slot="{errors}">
                        <b-form-input
                                name="password"
                                autocomplete="off"
                                v-model="password"
                                type="password" />
                        <span v-if="0" class="text-danger text-sm">{{ errors[0] }}</span>
                    </validation-provider>

                    <div class="flex flex-wrap">
                        <b-button :disabled="invalid" @click="login"><b-spinner small type="grow" v-if="loading"></b-spinner> Login</b-button>
                    </div>
                </validation-observer>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {toast} from "../utils/toast";

    export default {
        data() {
            return {
                loading: false,
                email: '',
                password: '',
                checkbox_remember_me: false,
            }
        },

        /**
         * Mounted
         */
        mounted() {

            // Check for logged in and go to tasks list
            if(this.$get("auth/currentUser").id)
            {
                // Go to tasks list
                this.$router.push({name: "home"});
            }

        },

        computed: {

        },
        methods: {
            checkLogin() {
                // If user is already logged in notify
                if (this.$store.state.auth.currentUser) {
                    toast.notify(this, 'Login Attempt', `You are already logged in!`, 'warning');
                    return false
                }
                return true
            },
            async login() {
                if (!this.checkLogin()) return;

                // Loading
                this.loading = true;

                const payload = {
                    checkbox_remember_me: this.checkbox_remember_me,
                    email: this.email,
                    password: this.password
                };

                this.$dispatch('auth/login', payload)
                    .then(() => {
                        // Navigate User to homepage
                        this.$router.push({name: "home"});

                        // close loader
                        this.loading = false;
                    })
                    .catch(() => {
                        // close loader
                        this.loading = false;
                        toast.notify(this, 'Error', 'Invalid credentials', 'danger');
                    })
            }
        }
    }
</script>

<style lang="scss">

    .login-page {
        height: 100vh;
        padding-top:calc(100vh / 2 - 150px);
    }

    .login-form
    {
        border:0px !important;
        margin-left:auto;
        margin-right:auto;
        max-width: 400px;
        //box-shadow: 5px 5px 5px #6663;

        .logo {
            height: 30px;
            float:right;
        }
    }

    .form-control
    {
        margin-bottom: 10px;
    }

</style>
